var _excluded = ["a11y", "className", "currentPage", "disabled", "id", "maxPagesToShow", "messages", "onPageChange", "resultsPerPage", "shouldShowPrevNextLabel", "totalResults", "isMobileView", "shouldShowFirstLastButton"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent, createRef, forwardRef, useState, useMemo, useImperativeHandle, useEffect } from 'react';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { Icon } from '@els/els-react--icon';
import { createEnum, ValidPropTypes, generateId, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
import { Flyout } from '@els/els-react--flyout';

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  jumpToFirstMessage: 'Jump to First',
  goToMessage: 'Go to',
  ofMessage: 'of',
  jumpToLastMessage: 'Jump to Last',
  nextText: 'Next',
  previousText: 'Previous',
  pagingUnitName: 'Page',
  morePagingUnit: 'More pages'
});
var bool$1 = PT.bool,
  func$1 = PT.func,
  number$1 = PT.number,
  object$1 = PT.object,
  string$1 = PT.string;
var PaginatorFlyout = /*#__PURE__*/function (_PureComponent) {
  function PaginatorFlyout(props) {
    var _this;
    _classCallCheck(this, PaginatorFlyout);
    _this = _callSuper(this, PaginatorFlyout, [props]);
    /*
     * Checks if given content is ellipsis or not.
     * @returns {boolean} - returns true if given content is ellipsis.
     */
    _defineProperty(_this, "isEllipsis", function (content) {
      return content === String.fromCharCode(8230);
    });
    /**
     * To close paginator flyout when user presses Tab from last button in the floyut.
     * @param {Event} event - keyup event
     */
    _defineProperty(_this, "focusHandler", function (event) {
      var isVisible = _this.ellipsisMenuRef.current.state.isVisible;
      if (event.key === "Tab" && isVisible && !event.target.className.includes("c-els-pagination-flyout-button__page-button")) {
        _this.ellipsisMenuRef.current.toggleVisibility(false);
      }
    });
    /**
     * Open Flyout menu via the up/down arrows.
     * Triggers when ellipsis button has focus.
     * @param {Event} e - keydown event
     */
    _defineProperty(_this, "handleEllipsisKeyDown", function (e) {
      if (e.key === "ArrowUp" || e.key === "Up" || e.key === "ArrowDown" || e.key === "Down") {
        e.preventDefault();
        e.target.click();
      }
    });
    /**
     * Navigates between page buttons in the Flyout menu.
     * Triggers when the buttons in the menu have focus.
     * Initial focus comes from `this.handleToggle`
     *  @param {Event} e - keydown event
     */
    _defineProperty(_this, "handleMenuPageKeyDown", function (e) {
      if (e.key === "ArrowUp" || e.key === "Up" || e.key === "ArrowDown" || e.key === "Down" || e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        var el;
        if (e.key === "ArrowDown" || e.key === "Down") {
          el = e.target.nextElementSibling;
        } else if (e.key === "ArrowUp" || e.key === "Up") {
          el = e.target.previousElementSibling;
        } else {
          el = document.getElementById("".concat(_this.id, "-ellipses-button"));
        }
        el.focus();
      }
    });
    _this.noop = function () {};
    _this.ellipsisMenuRef = createRef();
    _this.id = props.id || "flyout-paginator-".concat(generateId());
    _this.handlePageClick = _this.handlePageClick.bind(_this);
    _this.handleMenuPageKeyDown = _this.handleMenuPageKeyDown.bind(_this);
    return _this;
  }
  _inherits(PaginatorFlyout, _PureComponent);
  return _createClass(PaginatorFlyout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keyup", this.focusHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.focusHandler);
    }
    /**
     * Gets page number from DOM element
     * and call parent method where a regex is used to pullout the number from inner text,
     * After that if ParseInt returns correct number then update state and envokes the required handler
     * and selected page is focused and  at last toggleVisibility is triggered to close flyout menu.
     *  @param {Event} e - click event
     */
  }, {
    key: "handlePageClick",
    value: function handlePageClick(e) {
      var handlePageClick = this.props.handlePageClick;
      handlePageClick(e);
      document.getElementById("".concat(this.id, "-ellipses-button")).focus();
      this.ellipsisMenuRef.current.toggleVisibility(false);
    }
    /**
     * The flyout box should grows to accommodate a currentPage value with more digits.
     * Dynamtically applies a character width size plus 2 at the time of render to fit in more digits with proper spacing.
     * @returns {Object} - to be used in the style prop
     */
  }, {
    key: "getDisplayPaddingStyle",
    value: function getDisplayPaddingStyle() {
      var totalPages = this.props.totalPages;
      return {
        width: "".concat(totalPages.toString().length + 4, "ch")
      };
    }
    /**
     * Checks if the button which triggers the flyout shoudld be a page number or Ellipsis
     * @returns {String|Number} - returns the ellipsis string unless a page within the menu is selected, when it returns the page as a number
     */
  }, {
    key: "getMenuTriggerContent",
    value: function getMenuTriggerContent() {
      var _this$props = this.props,
        maxPagesToShow = _this$props.maxPagesToShow,
        currentPage = _this$props.currentPage,
        totalPages = _this$props.totalPages;
      if (currentPage > maxPagesToShow && currentPage < totalPages) {
        return currentPage;
      }
      return String.fromCharCode(8230);
    }
    /**
     * To generate flyout Menu dynamically for both desktop and mobile view.
     */
  }, {
    key: "getFlyoutMenu",
    value: function getFlyoutMenu() {
      var _this2 = this;
      var _this$props2 = this.props,
        isMobileView = _this$props2.isMobileView,
        maxPagesToShow = _this$props2.maxPagesToShow,
        messages = _this$props2.messages,
        totalPages = _this$props2.totalPages;
      var flyoutMenu = Array.from({
        length: totalPages - maxPagesToShow - 1
      }, function (v, i) {
        return maxPagesToShow + 1 + i;
      });
      if (isMobileView) {
        flyoutMenu = Array.from({
          length: totalPages
        }, function (v, i) {
          return i + 1;
        });
      }
      return flyoutMenu.map(function (pageNumber) {
        return /* @__PURE__ */React.createElement(Button, {
          "aria-current": _this2.isPageCurrent(pageNumber) && messages.PAGING_UNIT_NAME.toLowerCase(),
          className: classnames("c-els-pagination-flyout-button__page-button", {
            // eslint-disable-next-line prettier/prettier
            "c-els-pagination-flyout-button__page-button--active": _this2.isPageCurrent(pageNumber)
          }),
          "data-testid": "".concat(_this2.id, "-").concat(pageNumber),
          id: "".concat(_this2.id, "-page-button-").concat(pageNumber),
          onClick: _this2.handlePageClick,
          onKeyDown: _this2.handleMenuPageKeyDown,
          type: Button.Types.LINK,
          linkOptions: [Button.LinkOptions.NAVIGATION],
          key: "".concat(messages.PAGING_UNIT_NAME).concat(pageNumber),
          role: "option"
        }, /* @__PURE__ */React.createElement("span", {
          className: "c-els-pagination-flyout-button__page-button-content-unit u-els-hide-visually"
        }, messages.PAGING_UNIT_NAME), /* @__PURE__ */React.createElement("span", {
          className: "c-els-pagination-flyout-button__page-button-content"
        }, pageNumber));
      });
    }
  }, {
    key: "isPageCurrent",
    value:
    /**
     * Util for legibility.
     * @param {Number} targetPage - page to check if current
     */
    function isPageCurrent(targetPage) {
      var currentPage = this.props.currentPage;
      return currentPage === targetPage;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        currentPage = _this$props3.currentPage,
        disabled = _this$props3.disabled,
        id = _this$props3.id,
        isMobileView = _this$props3.isMobileView,
        messages = _this$props3.messages;
      var menuTriggerContent = this.getMenuTriggerContent();
      var activeEllipsisMenuSelection = typeof menuTriggerContent !== "string";
      var numPaddStyle = this.getDisplayPaddingStyle();
      var classNames = classnames("c-els-pagination-flyout-button__page-button", {
        // eslint-disable-next-line prettier/prettier
        "c-els-pagination-flyout-button__page-button--active": activeEllipsisMenuSelection
      });
      if (isMobileView) {
        classNames = classnames("c-els-pagination-flyout-button__page-mobile-button");
      }
      return /* @__PURE__ */React.createElement(Flyout, {
        "aria-label": "select page number",
        className: "c-els-pagination-flyout-button__ellipsis-menu",
        id: id,
        ref: this.ellipsisMenuRef,
        placement: Flyout.placementTypes.top,
        shouldCloseOnESC: true,
        flyout: this.getFlyoutMenu(),
        isControlled: disabled,
        isOpen: false,
        theme: "minimal"
      }, /* @__PURE__ */React.createElement(Button, {
        "aria-current": activeEllipsisMenuSelection && "page",
        "aria-haspopup": "listbox",
        className: classNames,
        "data-testid": "paginator-flyout-button",
        disabled: disabled,
        id: "".concat(this.id, "-ellipses-button"),
        onClick: this.noop,
        onKeyDown: this.handleEllipsisKeyDown,
        type: Button.Types.LINK,
        linkOptions: [Button.LinkOptions.NAVIGATION],
        style: isMobileView ? numPaddStyle : {}
      }, /* @__PURE__ */React.createElement("span", {
        className: "c-els-pagination-flyout-button__page-button-content-unit u-els-hide-visually"
      }, isMobileView || !this.isEllipsis(menuTriggerContent) ? messages.PAGING_UNIT_NAME : messages.MORE_PAGING_UNIT), /* @__PURE__ */React.createElement("span", {
        className: "c-els-pagination-flyout-button__page-button-content"
      }, isMobileView ? currentPage : menuTriggerContent)));
    }
  }]);
}(PureComponent);
PaginatorFlyout.propTypes = {
  currentPage: number$1,
  disabled: bool$1,
  handlePageClick: func$1,
  id: string$1,
  isMobileView: bool$1,
  maxPagesToShow: number$1,
  messages: object$1.isRequired,
  totalPages: number$1.isRequired
};
PaginatorFlyout.requiredProps = {
  messages: ValidPropTypes.OBJECT,
  totalPages: ValidPropTypes.NUMBER
};
PaginatorFlyout.defaultProps = {
  currentPage: 1,
  disabled: false,
  id: null,
  isMobileView: false,
  handlePageClick: null,
  maxPagesToShow: 5
};
var bool = PT.bool,
  func = PT.func,
  number = PT.number,
  object = PT.object,
  shape = PT.shape,
  string = PT.string;
var Paginator = forwardRef(function (_ref, ref) {
  var a11y = _ref.a11y,
    className = _ref.className,
    currentPage = _ref.currentPage,
    disabled = _ref.disabled,
    id = _ref.id,
    maxPagesToShow = _ref.maxPagesToShow,
    messages = _ref.messages,
    onPageChange = _ref.onPageChange,
    resultsPerPage = _ref.resultsPerPage,
    shouldShowPrevNextLabel = _ref.shouldShowPrevNextLabel,
    totalResults = _ref.totalResults,
    isMobileView = _ref.isMobileView,
    shouldShowFirstLastButton = _ref.shouldShowFirstLastButton,
    customProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(currentPage),
    _useState2 = _slicedToArray(_useState, 2),
    currentPageState = _useState2[0],
    setCurrentPageState = _useState2[1];
  var totalPages = useMemo(function () {
    return Math.ceil(totalResults / resultsPerPage);
  }, [totalResults, resultsPerPage]);
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var validateProps = function validateProps() {
    if (!a11y || _typeof(a11y) !== "object") {
      throw new TypeError("Paginator: must have an a11y object");
    }
    if (Array.isArray(a11y)) {
      throw new TypeError("Paginator: a11y should be an object, not an array");
    }
    if (typeof a11y.name !== "string") {
      throw new TypeError("Paginator: must have an a11y.name label");
    }
    if (typeof onPageChange !== "function") {
      throw new TypeError("Paginator: must have an onPageChange callback");
    }
    if (typeof resultsPerPage !== "number") {
      throw new TypeError("Paginator: must have resultsPerPage as a number");
    }
    if (resultsPerPage < 1) {
      throw new RangeError("Paginator: resultsPerPage must be greater than 0");
    }
    if (typeof totalResults !== "number") {
      throw new TypeError("Paginator: must have totalResults as a number");
    }
    if (Number.isNaN(totalResults)) {
      throw new TypeError("Paginator: totalResults received NaN");
    }
    if (totalResults < 1) {
      throw new RangeError("Paginator: totalResults must be greater than 0");
    }
    if (currentPage < 0) {
      throw new RangeError("Paginator: initial currentPage must be a positive number");
    }
    if (currentPage > totalPages) {
      throw new RangeError("Paginator: initial currentPage is not in range of totalPages");
    }
  };
  validateProps();
  useImperativeHandle(ref, function () {
    return {
      setCurrentPage: function setCurrentPage(newPage) {
        if (newPage < 1 || newPage > totalPages) {
          console.warn("Invalid page number supplied");
        } else {
          setCurrentPageState(newPage);
        }
      },
      getCurrentPage: function getCurrentPage() {
        return currentPageState;
      },
      nextPage: function nextPage() {
        if (currentPageState < totalPages) {
          var nextPageIndex = currentPageState + 1;
          setCurrentPageState(nextPageIndex);
        }
      },
      prevPage: function prevPage() {
        if (currentPageState > 1) {
          var prevPageIndex = currentPageState - 1;
          setCurrentPageState(prevPageIndex);
        }
      }
    };
  }, [currentPageState, totalPages]);
  var goToPage = function goToPage(newPage) {
    onPageChange(newPage, totalPages, currentPageState);
    setCurrentPageState(newPage);
  };
  var goToFirstPage = function goToFirstPage() {
    goToPage(1);
  };
  var goToPreviousPage = function goToPreviousPage() {
    goToPage(currentPageState - 1);
  };
  var goToNextPage = function goToNextPage() {
    goToPage(currentPageState + 1);
  };
  var goToLastPage = function goToLastPage() {
    goToPage(totalPages);
  };
  var handlePageClick = function handlePageClick(e) {
    var page = e.target.textContent;
    var digits = page.match(/\d+/)[0];
    var pageAsNumber = parseInt(digits, 10);
    goToPage(pageAsNumber);
  };
  var isPageCurrent = function isPageCurrent(targetPage) {
    return currentPageState === targetPage;
  };
  useEffect(function () {
    validateProps();
    setCurrentPageState(currentPage);
  }, [currentPage]);
  var name = a11y.name;
  var classes = classnames("c-els-pagination", className);
  var pagesToShow = [];
  var shouldShowEllipsis = false;
  var shouldShowLast = false;
  if (!isMobileView) {
    pagesToShow = Array.from({
      length: Math.min(maxPagesToShow, totalPages)
    }, function (v, i) {
      return i + 1;
    });
    shouldShowEllipsis = totalPages > maxPagesToShow + 1;
    shouldShowLast = totalPages > maxPagesToShow;
  }
  return /* @__PURE__ */React.createElement("nav", _objectSpread({
    "aria-label": name,
    className: classes,
    "data-testid": "paginator",
    id: id
  }, customProps), !isMobileView && shouldShowFirstLastButton && /* @__PURE__ */React.createElement(ButtonWithIcon, {
    className: "c-els-pagination__first-page-button",
    "data-testid": "paginator-first-page-button",
    disabled: disabled || currentPageState <= 1,
    id: id && "".concat(id, "-first-page-button"),
    onClick: goToFirstPage,
    type: ButtonWithIcon.Types.LINK,
    sprite: Icon.Sprites.JUMP_TO_FIRST,
    iconOnly: true,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "⏮";
    })
  }, compiledMessages.JUMP_TO_FIRST_MESSAGE, " -", " ", compiledMessages.GO_TO_MESSAGE, " ", compiledMessages.PAGING_UNIT_NAME.toLowerCase(), " 1", " ", compiledMessages.OF_MESSAGE, " ", totalPages), /* @__PURE__ */React.createElement(ButtonWithIcon, {
    className: "c-els-pagination__prev-page-button",
    "data-testid": "paginator-prev-page-button",
    disabled: disabled || currentPageState <= 1,
    id: id && "".concat(id, "-prev-page-button"),
    onClick: goToPreviousPage,
    type: Button.Types.LINK,
    linkOptions: [Button.LinkOptions.EMPHASIZED],
    sprite: Icon.Sprites.CHEVRON_LEFT,
    iconOnly: !isMobileView && shouldShowPrevNextLabel ? null : true,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "⏴";
    })
  }, /* @__PURE__ */React.createElement(React.Fragment, null, compiledMessages.PREVIOUS_TEXT, " ", /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, compiledMessages.GO_TO_MESSAGE, " ", compiledMessages.PAGING_UNIT_NAME.toLowerCase(), " ", currentPageState - 1, " ", compiledMessages.OF_MESSAGE, " ", totalPages))), isMobileView ? /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("span", {
    className: "c-els-pagination__page-mobile-text"
  }, compiledMessages.PAGING_UNIT_NAME), /* @__PURE__ */React.createElement(PaginatorFlyout, {
    currentPage: currentPageState,
    maxPagesToShow: maxPagesToShow,
    totalPages: totalPages,
    disabled: disabled,
    isMobileView: isMobileView,
    id: id && "".concat(id, "-mobile-flyout"),
    handlePageClick: handlePageClick,
    messages: compiledMessages
  }), /* @__PURE__ */React.createElement("span", {
    className: "c-els-pagination__page-mobile-text"
  }, "of ", totalPages)) : /* @__PURE__ */React.createElement(React.Fragment, null, pagesToShow.map(function (pageNumber) {
    return /* @__PURE__ */React.createElement(Button, {
      className: classnames("c-els-pagination__page-button", {
        "c-els-pagination__page-button--active": isPageCurrent(pageNumber)
      }),
      disabled: disabled || isPageCurrent(pageNumber),
      "aria-current": isPageCurrent(pageNumber) && "page",
      "data-testid": "paginator-page-button-".concat(pageNumber),
      id: id && "".concat(id, "-page-button-").concat(pageNumber),
      onClick: handlePageClick,
      type: Button.Types.LINK,
      linkOptions: [Button.LinkOptions.NAVIGATION],
      key: "".concat(id, "-page-button-").concat(pageNumber)
    }, /* @__PURE__ */React.createElement("span", {
      className: "c-els-pagination__page-button-content-unit u-els-hide-visually"
    }, compiledMessages.PAGING_UNIT_NAME), /* @__PURE__ */React.createElement("span", {
      className: "c-els-pagination__page-button-content"
    }, pageNumber));
  }), shouldShowEllipsis && /* @__PURE__ */React.createElement(PaginatorFlyout, {
    currentPage: currentPageState,
    id: id && "".concat(id, "-flyout"),
    maxPagesToShow: maxPagesToShow,
    totalPages: totalPages,
    disabled: disabled,
    isMobileView: isMobileView,
    handlePageClick: handlePageClick,
    isPageCurrent: isPageCurrent,
    messages: compiledMessages
  }), shouldShowLast && /* @__PURE__ */React.createElement(Button, {
    "aria-current": isPageCurrent(totalPages) && "page",
    className: classnames("c-els-pagination__page-button", {
      "c-els-pagination__page-button--active": isPageCurrent(totalPages)
    }),
    "data-testid": "paginator-last-page-button",
    disabled: disabled,
    id: id && "".concat(id, "-last-page-button"),
    onClick: goToLastPage,
    type: Button.Types.LINK,
    linkOptions: [Button.LinkOptions.NAVIGATION]
  }, /* @__PURE__ */React.createElement("span", {
    className: "c-els-pagination__page-button-content-unit u-els-hide-visually"
  }, compiledMessages.PAGING_UNIT_NAME), /* @__PURE__ */React.createElement("span", {
    className: "c-els-pagination__page-button-content"
  }, totalPages))), /* @__PURE__ */React.createElement(ButtonWithIcon, {
    className: "c-els-pagination__next-page-button",
    "data-testid": "paginator-next-page-button",
    disabled: disabled || currentPageState >= totalPages,
    id: id && "".concat(id, "-next-page-button"),
    onClick: goToNextPage,
    type: Button.Types.LINK,
    linkOptions: [Button.LinkOptions.EMPHASIZED],
    sprite: Icon.Sprites.CHEVRON_RIGHT,
    iconOnly: !isMobileView && shouldShowPrevNextLabel ? null : true,
    iconRight: true,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "⏵";
    })
  }, /* @__PURE__ */React.createElement(React.Fragment, null, compiledMessages.NEXT_TEXT, " ", /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, compiledMessages.GO_TO_MESSAGE, " ", compiledMessages.PAGING_UNIT_NAME.toLowerCase(), " ", currentPageState + 1, " ", compiledMessages.OF_MESSAGE, " ", totalPages))), !isMobileView && shouldShowFirstLastButton && /* @__PURE__ */React.createElement(ButtonWithIcon, {
    className: "c-els-pagination__last-page-button",
    "data-testid": "paginator-jump-to-last-page-button",
    disabled: disabled || currentPageState >= totalPages,
    id: id && "".concat(id, "-jump-to-last-page-button"),
    onClick: goToLastPage,
    type: Button.Types.LINK,
    iconOnly: true,
    sprite: Icon.Sprites.JUMP_TO_LAST,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "⏭";
    })
  }, "".concat(compiledMessages.JUMP_TO_LAST_MESSAGE, "\n                        ").concat(compiledMessages.GO_TO_MESSAGE, " ").concat(compiledMessages.PAGING_UNIT_NAME.toLowerCase(), " ").concat(totalPages, " ").concat(compiledMessages.OF_MESSAGE, " ").concat(totalPages)));
});
Paginator.displayName = "Paginator";
Paginator.DefaultMessages = DefaultMessages;
Paginator.propTypes = {
  /**
   * Contains accessibility relevant properties
   * name: The value used to label the paginator. Consider that more than 1 paginator may be on screen at a time
   * */
  a11y: shape({
    name: string.isRequired
  }).isRequired,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** Initial starting page */
  currentPage: number,
  /** Disables all pagination buttons, regardless of currentPage */
  disabled: bool,
  /** unique id */
  id: string,
  /** To show mobile version of paginator */
  isMobileView: bool,
  /** The max number of page buttons to display before the ellipsis */
  maxPagesToShow: number,
  /** Messages for internationalization */
  messages: object,
  /** Number of items from the data set to be displayed per page  */
  resultsPerPage: number.isRequired,
  /** Adjust display of First and Last buttons */
  shouldShowFirstLastButton: bool,
  /** Adjust display of Next and Previous button text */
  shouldShowPrevNextLabel: bool,
  /** Number of items in the paginating data set */
  totalResults: number.isRequired,
  /**
   * Callback to execute on page change
   * @param {Number} newPage - Selected page to navigate to
   * @param {Number} totalPages- Total pages in the dataset
   * @param {Number} oldPage- Page navigated from
   * */
  onPageChange: func.isRequired
};
Paginator.requiredProps = {
  a11y: {
    name: ValidPropTypes.STRING
  },
  onPageChange: ValidPropTypes.FUNCTION,
  resultsPerPage: ValidPropTypes.NUMBER,
  totalResults: ValidPropTypes.NUMBER
};
Paginator.defaultProps = {
  className: "",
  currentPage: 1,
  disabled: false,
  id: null,
  maxPagesToShow: 5,
  messages: DefaultMessages,
  shouldShowPrevNextLabel: false,
  isMobileView: false,
  shouldShowFirstLastButton: false
};
var RawPaginator = Paginator;
var Paginator$1 = makeErrorBoundComponent(RawPaginator);
export { Paginator$1 as Paginator, RawPaginator };
